<template>
	<div class="product">
		<editor-product-filters @search="onSearch" class="product__filters" />
		<div class="product__table-bar">
			<span class="product__table-bar__status">
				검색결과: 전체 {{ contentTotal | currency }}건 (전시예정
				{{ status.ready ? status.ready : 0 | currency }} / 전시중
				{{ status.open ? status.open : 0 | currency }} / 비전시
				{{ status.closed ? status.closed : 0 | currency }})
			</span>
			<button
				@click="excelDownload"
				class="btn-excel product__table-bar__excel"
			>
				엑셀 다운로드
			</button>
		</div>
		<editor-product-table
			:product-list="productList"
			@modify="onModify"
			@remove="onRemove"
		/>
		<pagination-box
			:totalItem="contentTotal"
			:limit="limit"
			:offset="offset"
			:pageLengPerOne="10"
			@to="onPaging"
		/>
	</div>
</template>
<script>
	import util from '@/util.js';
	import { stringify } from 'query-string';
	import EditorProductFilters from '@/components/product/EditorProductFilters';
	import EditorProductTable from '@/components/product/EditorProductTable';
	import PaginationBox from '@/components/PaginationBox';

	export default {
		name: 'EditorProductList',
		components: {
			EditorProductFilters,
			EditorProductTable,
			PaginationBox,
		},
		data() {
			return {
				productList: [],
				searchParams: {},
				offset: 0,
				limit: 10,
				contentTotal: 0,
				status: {},
			};
		},
		mounted() {
			this.getProductList();
		},
		methods: {
			getProductList() {
				const searchParams = {
					...this.searchParams,
					offset: this.offset,
					limit: this.limit,
				};

				this.$axiosAdmin2
					.get(`/api/hotediters?${stringify(searchParams)}`)
					.then(({ data }) => {
						if (data.data.length === 0 && this.offset !== 0) {
							this.offset = this.offset - this.limit;
							this.getProductList();
						} else {
							this.contentTotal = data.contentTotal;
							this.productList = data.data;
							this.status = data.hasOwnProperty('statusTotal')
								? data.statusTotal
								: {};
						}
					})
					.catch(({ response }) => {
						console.error(response);
					});
			},
			onSearch(event) {
				this.searchParams = event;
				this.getProductList();
			},
			onModify(event) {
				this.$router.push(`/product/editor-product/modify/${event.id}`);
			},
			onRemove(event) {
				if (!confirm('등록된 추천제품을 정말 삭제하시겠습니까?')) {
					return false;
				}

				this.$axiosAdmin2
					.delete(`/api/hotediters/${event.id}`)
					.then(({ data }) => {
						this.getProductList();
					})
					.catch(({ response }) => {
						alert('삭제중 오류가 발생했습니다.');
						console.error(response);
					});
			},
			onPaging(event) {
				this.offset = event.offset;
				this.getProductList();
			},
			async excelDownload() {
				let selfDestroyTimeout;
				const searchParams = {
					...this.searchParams,
					offset: this.offset,
					limit: this.limit,
				};

				const url = `/api/hotediters/export?${stringify(searchParams)}`;
				const res = await this.$axiosAdmin2.get(url, {
					responseType: 'blob',
				});
				util.exportExcel(res);
			},
		},
	};
</script>
<style lang="scss">
	.product {
		margin-top: 24px;
	}

	.product__filters {
		margin-bottom: 72px;
	}

	.product__table-bar {
		position: relative;
		margin-bottom: 24px;

		&:after {
			display: block;
			clear: both;
		}
	}

	.product__table-bar__excel {
		position: relative;
		top: -8px;
		float: right;
	}
</style>
